import React from 'react'
import styled from 'styled-components'
import { useFarmUser , useFarmFromPid } from 'state/hooks'
import useI18n from 'hooks/useI18n'
import { Text, Image } from '@pancakeswap-libs/uikit'
import { getBalanceNumber } from 'utils/formatBalance'
import { CommunityTag, CoreTag, NoFeeTag } from 'components/Tags'

export interface FarmProps {
  label: string
  pid: number
  image: string
  version: string
}

const IconImage = styled(Image)`
  width: 24px;
  height: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 40px;
    height: 40px;
  }
`


const IconImageAnim = styled(Image)`
  width: 24px;
  height: 24px;
  margin-left: 10px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 40px;
    height: 40px;
  }
`

const Container = styled.div`
  padding-left: 16px;
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-left: 32px;
  }
`

const Farm: React.FunctionComponent<FarmProps> = ({ image, label, pid , version }) => {
  const { stakedBalance } = useFarmUser(pid)
  const { depositFeeBP } = useFarmFromPid(pid)
  const TranslateString = useI18n()
  const rawStakedBalance = getBalanceNumber(stakedBalance)

  const handleRenderFarming = (): JSX.Element => {
    if (rawStakedBalance) {
      return (
        <div>
        <Text color="secondary" fontSize="12px" bold>
          {TranslateString(999, 'FARMING')}
        </Text>
        </div>
      )
    }

    return null
  }

  const handleAnimFarming = (): JSX.Element => {
    if (rawStakedBalance) {
      return (
        <IconImageAnim src='/images/Money-1s-200px.svg' alt='anim' width={64} height={64} />  
      )
    }

    return null
  }  

  return (
    <Container>
      <IconImage src={`/images/farms/${image}.svg`} alt="icon" width={40} height={40} mr="8px" />      

      <div>
        <Text bold>{label}</Text>
         {/* {depositFeeBP === 0 ? <NoFeeTag /> : null} */}
      </div>      
        {handleAnimFarming()}
    </Container>
  )
}

export default Farm
